import { Catalogue_SystemSettingsViewType } from '@tyro/api';
import { useMemo } from 'react';
import { getSettingsValues, useSettingsValues } from '../api/settings-values';

export async function getPersonalSettings() {
  const { catalogue_systemSettingsValues: settingsValues } =
    await getSettingsValues({
      type: Catalogue_SystemSettingsViewType.Personal,
      module: [],
    });

  return settingsValues;
}

export const usePersonalSettings = () => {
  const { data, isLoading } = useSettingsValues({
    type: Catalogue_SystemSettingsViewType.Personal,
    module: [],
  });

  return useMemo(() => ({ ...data, isLoading }), [data, isLoading]);
};

export type ReturnTypeFromGetPersonalSettings = NonNullable<
  Awaited<ReturnType<typeof getPersonalSettings>>
>;
